// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"FP-z","inlineTitle":"GP-z","sponsoredAdsWrapper":"HP-z","marketplaceRecosWrapper":"IP-z"};